declare global {
    interface Window {
        env: { apiUrl: string };
    }
}

export const environment = {
    production: true,
    endpoint: window.env.apiUrl ?? 'https://01.backend-bevis.p.orgacard.de',
};
